<template>
    <div id="p2">
        <img src="@/assets/active/new-year/p21.png" alt="">
        <img src="@/assets/active/new-year/p22.png" alt="">
        <img src="@/assets/active/new-year/p23.png" alt="">
        <img src="@/assets/active/new-year/p24.png" alt="">
    </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
#p2 {
    height: 100vh;
    width: 100vw;
    background: #111125;;
    position: relative;
    padding-bottom: 120px;
    img {
        pointer-events: none;
        width: 100vw;
        height: auto;
    }
    .img-box {
        width: 100%;
        height: 100%;
        overflow: auto;
    }
}
</style>